import React from 'react';
import { Navigate, Route, useParams } from 'react-router-dom';
import { usePagePayload } from './usePagePayload';
import SuburbPage from './pages/SuburbPage';
import AgentPage from './pages/AgentPage';
import SuburbIndexPage from './pages/SuburbIndexPage';
import MethodologyPage from './pages/MethodologyPage';
import SeoNotFoundPage from './pages/SeoNotFoundPage';

function PageState({ result, children }) {
  if (result.status === 'ready') return children(result.payload);
  if (result.status === 'not-found') return <SeoNotFoundPage />;
  if (result.status === 'error') {
    return (
      <main className="re-seo" id="main">
        <div className="re-seo__inner">
          <p className="re-empty">This page couldn&rsquo;t be loaded. Check your connection and try again.</p>
        </div>
      </main>
    );
  }
  return (
    <main className="re-seo re-seo--loading" id="main" aria-busy="true">
      <div className="re-seo__inner">
        <div className="re-skeleton re-skeleton--title" />
        <div className="re-skeleton re-skeleton--line" />
        <div className="re-skeleton re-skeleton--block" />
      </div>
    </main>
  );
}

function SuburbRoute() {
  const { slug } = useParams();
  const result = usePagePayload('suburb', slug);
  return <PageState result={result}>{(payload) => <SuburbPage key={payload.slug} payload={payload} />}</PageState>;
}

function AgentRoute() {
  const { slug } = useParams();
  const result = usePagePayload('agent', slug);
  return <PageState result={result}>{(payload) => <AgentPage key={payload.slug} payload={payload} />}</PageState>;
}

function SuburbIndexRoute() {
  const result = usePagePayload('suburb-index', 'index');
  return <PageState result={result}>{(payload) => <SuburbIndexPage payload={payload} />}</PageState>;
}

/**
 * Route elements shared by the client app (App.js) and the build-time
 * renderer (ssrEntry.jsx), so both produce the same tree for these URLs.
 */
export const seoRoutes = [
  <Route key="suburb-index" path="/suburbs" element={<SuburbIndexRoute />} />,
  <Route key="suburb" path="/suburbs/:slug" element={<SuburbRoute />} />,
  <Route key="suburb-deep" path="/suburbs/*" element={<SeoNotFoundPage />} />,
  <Route key="agent-index" path="/agents" element={<Navigate to="/leaderboard" replace />} />,
  <Route key="agent" path="/agents/:slug" element={<AgentRoute />} />,
  <Route key="agent-deep" path="/agents/*" element={<SeoNotFoundPage />} />,
  <Route key="methodology" path="/methodology" element={<MethodologyPage />} />,
];

export const SEO_PATH_PREFIXES = ['/suburbs', '/agents', '/methodology'];

export function isSeoPath(pathname) {
  return SEO_PATH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}
